import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]

  connect() {
    // Controller verbunden
  }

  show(event) {
    event.preventDefault()
    this.tooltipTargets.forEach(tooltip => {
      // Positioniere das Tooltip relativ zum Mauszeiger
      const rect = this.element.getBoundingClientRect()
      const tooltipRect = tooltip.getBoundingClientRect()
      
      // Positioniere oberhalb des Elements, zentriert
      tooltip.style.left = `${rect.left + (rect.width / 2) - (tooltipRect.width / 2)}px`
      tooltip.style.top = `${rect.top - tooltipRect.height - 10}px`
      
      tooltip.classList.remove('opacity-0', 'invisible')
      tooltip.classList.add('opacity-100')
    })
  }

  hide(event) {
    event.preventDefault()
    this.tooltipTargets.forEach(tooltip => {
      tooltip.classList.add('opacity-0', 'invisible')
      tooltip.classList.remove('opacity-100')
    })
  }

  toggle(event) {
    event.preventDefault()
    this.tooltipTargets.forEach(tooltip => {
      if (tooltip.classList.contains('opacity-0')) {
        tooltip.classList.remove('opacity-0', 'invisible')
        tooltip.classList.add('opacity-100')
      } else {
        tooltip.classList.add('opacity-0', 'invisible')
        tooltip.classList.remove('opacity-100')
      }
    })
  }
}
